export default "__VITE_ASSET__xwoLDZLa__"